<template>
    <div id="main">
        <div class="main-box">
            <div class="details_title">{{$t('details.OrderDetails')}}</div>
            <div class="details_list" :style="list_h">
                <div class="details_input">
                    <div class="status_tag tag_default" :class="orderInfo ? orderInfo.displayStatus : null">
                        {{orderInfo ? this.$t(orderInfo.displayStatus) : null}}
                    </div>
                    <div class="status_tag Exp" v-if="exp">{{$t('Exp')}}</div>
                    <div class="status_tag Unstored" v-if="unstored">{{$t('Unstored')}}</div>
                    <div class="list_title">{{$t('details.OrderID')}}</div>
                    <div class="list_input"><span>{{orderInfo ? orderInfo.expressNumber: null}}</span></div>
                </div>
                <div class="details_input">
                    <div class="list_title">{{$t('details.NewLabelNumber')}}</div>
                    <div class="list_input"><span>{{orderInfo ? orderInfo.newLabelNumber : null}}</span></div>
                </div>
                <div class="details_input">
                    <div class="list_title">{{$t('details.Logistics')}}</div>
                    <div class="list_input"><span>{{orderInfo ? orderInfo.logisticsName : null}}</span></div>
                </div>
                <div class="details_input">
                    <div class="list_title">{{$t('details.Recipient')}}</div>
                    <div class="list_input"><span>{{orderInfo ? (orderInfo.recipientName?orderInfo.recipientName + ' ':'') + (orderInfo.recipientPhoneNumber?orderInfo.recipientPhoneNumber:'') : null}}</span>
                    </div>
                </div>
                <div class="details_input" v-if="show.stored">
                    <div class="list_title">{{$t('details.TimeStored')}}</div>
                    <div class="list_input"><span>{{orderInfo&&orderInfo.timeStored ? dateFormat(orderInfo.timeStored) : '-'}}</span>
                    </div>
                </div>
                <div class="details_input" v-if="show.collected">
                    <div class="list_title">{{$t('details.TimeCollected')}}</div>
                    <div class="list_input"><span>{{orderInfo&&orderInfo.timeCollected ? dateFormat(orderInfo.timeCollected) : '-'}}</span>
                    </div>
                </div>
            </div>
            <div v-if="detailsEdit" class="details_edit">
                <div class="details_input">
                    <div class="edit_title">{{$t('details.Notes')}}</div>
                    <div class="edit_input">{{note}}</div>
                    <span class="edit_a" @click="edit">{{$t('details.Edit')}}</span>
                </div>
            </div>
            <div class="button-box">
                <button class="details_bt_w" @click="back()">{{$t('common.Back')}}</button>
                <button class="details_bt_b" v-if="showScanStore" @click="scanCollected()">{{$t('common.ScanToStore')}}</button>
                <button class="details_bt_b" v-if="showScanReturn" @click="scanReturn('')">{{$t('common.ScanToReturn')}}</button>
                <button class="details_bt_b" v-if="showScanBarcode" @click="scanBarcoded('')">{{$t('common.ScanBarcode')}}</button>
            </div>
            <bottom></bottom>
        </div>
        <div v-if="showNote" class="curtain" :style="{opacity:'50%'}"></div>
        <div v-if="showNote" class="remark_details_edit">
            <div class="remark_details_input">
                <div class="remark_edit_title">{{$t('details.EditNotes')}}</div>
                <div>
                    <textarea v-model="note_text" class="remark_edit_input">{{note_text}}</textarea>
                    <div class="save-cancel-box">
                        <a @click="save" class="remark_edit_a remark_edit_a_blue">{{$t('common.Save')}}</a>
                        <a @click="cancel" class="remark_edit_a remark_edit_a_gray">{{$t('common.Cancel')}}</a>
                    </div>
                    <div class="remark_scan-note" @click="scanNote">
                        <img class="remark_scan-icon" src="../../assets/image/common/scan.png" alt="">
                        <span>{{$t('details.ScanParcel')}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import bottom from '../Bottom.vue'

export default {
  name: 'Details',
  data () {
    return {
      action: null,
      status: null,
      exp: false,
      unstored: false,
      actionText: null,
      type_bg: this.type_bg,
      list_h: this.list_h,
      orderInfo: null,
      orderId: null,
      pin: null,
      note: null,
      detailsEdit: true,
      showNote: false,
      note_text: null,
      show: {
        store: false,
        stored: false,
        collected: false,
        returned: false
      },
      showScanStore: false,
      showScanReturn: false,
      showScanBarcode: false
    }
  },
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background-color: #f8f8f8;'
  },
  created () {
    this.init()
    // this.orderId = this.$route.query.order
    // this.pin = this.$route.query.pin
    // this.unstored = Number(this.$route.query.unstored)
    // const vue = this
    // // 根据orderId查询
    // this.axios({
    //   method: 'get',
    //   url: this.api.orderDetail + this.orderId
    // }).then(function (response) {
    //   vue.orderInfo = response.data
    //   vue.note = response.data.note
    //   vue.note_text = response.data.note
    //   vue.status = response.data.displayStatus
    //   vue.exp = response.data.overdueFlag
    //   if (vue.exp) {
    //     if (vue.$route.query.action && vue.$route.query.action === 'collectingPointTakeExpress') {
    //       vue.showScanReturn = false
    //     } else {
    //       vue.showScanReturn = true
    //     }
    //   }
    //   let scanResult = vue.$route.query.scanNote
    //   if (scanResult) {
    //     vue.showNote = true
    //     vue.note_text = scanResult
    //   }
    //   vue.parseStatus()
    // }).catch(function (error) {
    //   console.log(error)
    //   if (error.data.message) {
    //     alert(error.data.message)
    //   }
    //   vue.$router.back()
    // })
  },
  methods: {
    // 根据当前状态决定显示哪些字段
    init (hideNode = false) {
      this.orderId = this.$route.query.order
      this.pin = this.$route.query.pin
      this.action = this.$route.query.action
      this.original_action = this.$route.query.original_action
      this.unstored = Number(this.$route.query.unstored)
      const vue = this
      // 根据orderId查询
      this.axios({
        method: 'get',
        url: this.api.orderDetail + this.orderId
      }).then(function (response) {
        vue.orderInfo = response.data
        vue.note = response.data.note
        vue.note_text = response.data.note
        vue.status = response.data.displayStatus
        vue.exp = response.data.overdueFlag
        if (vue.original_action) {
          vue.action = vue.original_action
        }
        if (vue.exp) {
          if (vue.$route.query.action && vue.$route.query.action === 'collectingPointTakeExpress') {
            vue.showScanReturn = false
          } else {
            vue.showScanReturn = true
          }
        }
        let scanResult = vue.$route.query.scanNote
        if (scanResult && !hideNode) {
          vue.showNote = true
          vue.note_text = scanResult
        }
        vue.parseStatus()
      }).catch(function (error) {
        console.log(error)
        if (error.data.message) {
          alert(error.data.message)
        }
        vue.$router.back()
      })
    },
    parseStatus () {
      let status = this.status
      switch (status) {
        case 'Arriving':
          this.showScanStore = true
          this.detailsEdit = false
          break
        case 'Stored':
          this.show.stored = true
          // 如果操作行为是扫码取件，需要显示扫码取件的按钮,需要判断是否逾期。如果已逾期则不显示
          if (this.$route.query.action === 'collectingPointTakeExpress') {
            this.showScanReturn = false
            this.showScanBarcode = true
          }
          if ((this.$route.query.action !== 'collectExpiredExpress' && this.$route.query.original_action !== 'collectExpiredExpress') && (this.$route.query.action !== 'merchantTakeExpress' && this.$route.query.original_action !== 'merchantTakeExpress')) {
            this.showScanBarcode = true
          }
          // if (this.$route.query.action === undefined || this.$route.query.action === null || this.$route.query.action === '') {
          //   this.showScanBarcode = false
          // }
          break
        case 'Collected':
          this.show.stored = true
          this.show.collected = true
          this.showScanReturn = false
          break
        case 'Returns':
          this.show.stored = true
          this.showScanReturn = true
          break
        case 'Returned':
          this.show.stored = true
          this.show.returned = true
          break
        case 'Expired returned':
          this.showScanStore = false
          this.showScanReturn = false
          break
        default:
          break
      }
    },
    scanBarcoded () {
      this.$router.push({
        name: 'Barcode',
        query: {action: 'collectingPointTakeExpress', expressNumber: this.orderInfo.expressNumber, pin: this.pin}
      })
    },
    scanAction (action = '') {
      switch (action) {
        // 取件 - 扫码签出给客户
        case 'collectingPointTakeExpress':
          this.$router.push({
            name: 'Barcode',
            query: {action: this.action, expressNumber: this.orderInfo.expressNumber}
          })
          break
        case 'merchantTakeExpress':
          this.$router.push({
            name: 'Barcode',
            query: {action: this.action, expressNumber: this.orderInfo.expressNumber}
          })
          break
        case 'collectExpiredExpress':
          let logisticsId = this.$route.query.logisticsId
          this.$router.push({
            name: 'Barcode',
            query: {action: this.action, expressNumber: this.orderInfo.expressNumber, logisticsId: logisticsId}
          })
          break
        default:
          break
      }
    },
    scanCollected () {
      this.$router.push({
        name: 'Barcode',
        query: {action: 'collectingPointStoreExpress'}
      })
    },
    scanReturn () {
      let status = this.status
      let tag = ''
      if (status === 'Returns') {
        tag = 'courier'
      }
      if (this.exp) {
        tag = 'expired'
      }
      // let name = this.orderInfo.logisticsName
      // this.$router.push('/order/selectcompany?action=select&tag=' + tag + '&cname=' + name)
      // this.$router.push('/barcode?action=collectExpiredExpress&logisticsId=' + this.$route.query.logisticsId)
      // let url = '/barcode?action=collectExpiredExpress&order=' + this.$route.query.order + '&logisticsId=' + this.$route.query.logisticsId + '&original_action=' + this.original_action + '&expressNumber=' + this.orderInfo.expressNumber
      this.$router.push('/barcode?action=collectExpiredExpress&order=' + this.$route.query.order + '&logisticsId=' + this.$route.query.logisticsId + '&original_action=' + this.original_action + '&expressNumber=' + this.orderInfo.expressNumber + '&next=true' + (this.orderInfo.newLabelNumber ? '&newLabelNumber=' + this.orderInfo.newLabelNumber : ''))
    },
    edit () {
      this.showNote = true
    },
    cancel () {
      this.showNote = false
      this.init(true)
    },
    back () {
      this.$router.go(-1)
    },
    dateFormat (time) {
      let monthArr = this.$t('common.monthArr')
      time = new Date(time)
      let m = monthArr[time.getMonth()] // + this.$t('common.space')
      let d = time.getDate() + this.$t('common.dayFormat') + this.$t('common.space')
      let h = time.getHours()
      if (h.toString().length === 1) {
        h = '0' + h
      }
      let mm = time.getMinutes()
      if (mm.toString().length === 1) {
        mm = '0' + mm
      }
      let dateStr = d + m + ', ' + h + ':' + mm
      return dateStr
    },
    scanNote (e) {
      e.stopPropagation()
      let orderId = this.orderId
      this.$router.push('/barcode?action=scanNote&orderId=' + orderId + '&from=Details' + '&original_action=' + this.action + '&logisticsId=' + this.$route.query.logisticsId)
    },
    save () {
      const vue = this
      this.axios({
        method: 'post',
        url: this.api.updateOrderNote,
        data: {
          note: vue.note_text,
          ordersId: vue.orderId
        }
      }).then(function (response) {
        vue.showNote = false
        vue.note = response.data.note
      }).catch(function (error) {
        console.log(error)
      }).finally(function () {
        vue.init(true)
      })
    }
  },
  components: {bottom}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" src="../../assets/css/order/details.css" scoped>
</style>
<style scoped>
    .Arriving {
        /* background: rgba(5, 36, 96, 0.5); */
        background: #E6E6E6;
        color: var(--primary-text-color) !important;
        font-weight: normal !important;
    }

    .Stored {
        /* background: rgba(31, 141, 197, 0.5); */
        background: #E8FCEE;
        color: var(--primary-text-color) !important;
        font-weight: normal !important;
    }
    .Created{
        padding: 0 0.13rem;
        border-radius: 0.1rem;
        /* color: rgba(255,255,255,1); */
        margin-left: 0.93%;
        /* background: rgba(226,161,72,0.5); */
        background: #E8FCEE;
        color: var(--primary-text-color) !important;
        font-weight: normal !important;
    }
    .Collected {
        /* background: rgba(0, 172, 78, 0.5); */
        background: #E8FCEE;
        color: var(--primary-text-color) !important;
        font-weight: normal !important;
    }

    .Returns {
        /* background: rgba(178, 70, 154, 0.5); */
        background: #E6E6E6;
        color: var(--primary-text-color) !important;
        font-weight: normal !important;
    }
    .Returned{
        /* background:rgba(0,172,78,0.5); */
        background: #E8FCEE;
        color: var(--primary-text-color) !important;
        font-weight: normal !important;
    }
    .Unstored{
        color:rgba(247,148,29,1);
        padding: 0 0.09rem;
        background: rgba(255,255,255,0.5);
        border: 1px solid rgba(247,148,29,1);
        border-radius: 0.1rem;
        text-align: center;
    }
    .status_tag {
        float: right;
        margin-right: 0.03rem;
        height: 0.2rem;
        line-height: 0.2rem;
        text-align: center;
        font-size: 0.15rem;
    }
    .tag_default{
        padding: 0 .13rem;
        border-radius: .1rem;
        color: #fff;
    }
    .main-box{
        position: relative;
        z-index: 1;
    }
    .remark_details_edit {
        position: fixed;
        z-index: 3;
    }

    .remark_scan-note {
        position: absolute;
        padding-left: 0.15rem;
        padding-right: 0.15rem;
        font-weight: 400;
        color: #5A5A5A;
        top: 2.4rem;
        left: 50%;
        transform: translate(-50%, 0%);
        /* left: 0.7rem; */
        /* width: auto; */
        width: max-content;
        height: 0.3rem;
        line-height: 0.3rem;
        background: #fff;
        box-shadow: -0.03rem 0.06rem 0.09rem rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 0.13rem;
        font-size: 0.15rem;
    }

    .remark_scan-icon {
        height: 50%;
    }

    .save-cancel-box {
        display: flex;
        flex-direction: row-reverse;
    }

    .curtain {
        height: 7.4rem;
        width: 100%;
        background: #0f0f0f;
        /*opacity: 50% !important;*/
        position: fixed;
        top: 0;
        z-index: 2;
        left: 0;
    }
    .details_list{
        padding: 0.01rem 0;
    }
    .details_list .details_input{
        height: auto;
        float: unset;
    }
    .button-box{
        width: 100%;
        /* position: fixed; */
        position: sticky;
        bottom: 0.3rem;
    }
    .bottom{
        /*position: fixed;*/
        /*bottom: 0.06rem;*/
        margin-top: 1.6rem !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Order/Details.vue